export default "__VITE_ASSET__bd498af2__"